import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Global ChunkLoadError safety net.
// Some chunk-load failures fire OUTSIDE a React render boundary
// (e.g. when react-router resolves a route and the prefetch fetches a
// missing chunk). Those bypass `RouteErrorBoundary`. We listen at the
// window level and, on detection, reload the page once with a marker
// in sessionStorage to avoid a reload loop. Belt-and-suspenders.
const _CHUNK_RELOAD_KEY = "__btc_bot_chunk_reload_attempted__";
const _isChunkLoadError = (err) => {
  if (!err) return false;
  const name = err?.name || "";
  const msg = String(err?.message || err);
  return (
    name === "ChunkLoadError" ||
    /Loading chunk \S+ failed/i.test(msg) ||
    /Loading CSS chunk \S+ failed/i.test(msg) ||
    /Failed to fetch dynamically imported module/i.test(msg) ||
    /Importing a module script failed/i.test(msg)
  );
};
const _handleChunkLoadError = (err) => {
  if (!_isChunkLoadError(err)) return;
  try {
    if (window.sessionStorage.getItem(_CHUNK_RELOAD_KEY)) return; // avoid loop
    window.sessionStorage.setItem(_CHUNK_RELOAD_KEY, String(Date.now()));
    // eslint-disable-next-line no-console
    console.warn("[chunk-load-error] reloading page to pick up new build", err);
    window.location.reload();
  } catch {
    /* ignore — RouteErrorBoundary still renders the fallback. */
  }
};
window.addEventListener("error", (e) => _handleChunkLoadError(e?.error || e?.message));
window.addEventListener("unhandledrejection", (e) => _handleChunkLoadError(e?.reason));

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
